__turbopack_context__.v({
  "formRadioControl": "radio-module-scss-module__rMxZca__formRadioControl",
  "formRadioGroup": "radio-module-scss-module__rMxZca__formRadioGroup",
  "formRadioGroupVertical": "radio-module-scss-module__rMxZca__formRadioGroupVertical",
  "formRadioLabel": "radio-module-scss-module__rMxZca__formRadioLabel",
  "subLabel": "radio-module-scss-module__rMxZca__subLabel",
});
